import Rellax from 'rellax'

function parallax() {
  Rellax('[data-parallax]', {
    speed: -2,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: true,
  })
}

export default parallax
